import type { DotControl, DotSettings, DotSummary } from "./types";

export function isStale(
  control: DotControl,
  staleDays: number
): boolean {
  if (!control.updated_at || !control.status) return false;
  const updated = new Date(control.updated_at).getTime();
  if (Number.isNaN(updated)) return false;
  const ageMs = Date.now() - updated;
  return ageMs > staleDays * 24 * 60 * 60 * 1000;
}

export function isGap(control: DotControl): boolean {
  if (control.status === "No") return true;
  if (
    control.status === "Yes" &&
    !(control.comments || "").trim() &&
    !control.pid_mapped
  ) {
    return true;
  }
  if (
    control.status === "Yes" &&
    control.pid_mapped &&
    control.override &&
    !(control.override_reason || "").trim()
  ) {
    return true;
  }
  return false;
}

export function computeSummary(
  controls: DotControl[],
  settings: DotSettings
): DotSummary {
  const total = controls.length;
  let yes = 0;
  let no = 0;
  let unset = 0;
  let na = 0;
  let gaps = 0;
  let stale = 0;
  let pid_mapped = 0;
  let overridden = 0;

  for (const c of controls) {
    if (c.pid_mapped) pid_mapped += 1;
    if (c.override) overridden += 1;
    if (c.na) {
      na += 1;
      continue;
    }
    if (c.status === "Yes") yes += 1;
    else if (c.status === "No") no += 1;
    else unset += 1;
    if (isGap(c)) gaps += 1;
    if (isStale(c, settings.stale_days)) stale += 1;
  }

  const applicable = total - na;
  const score =
    applicable === 0 ? 0 : Math.round((yes / applicable) * 1000) / 10;
  const answered = yes + no;
  const readiness_pct =
    applicable === 0 ? 0 : Math.round((answered / applicable) * 1000) / 10;

  return {
    total,
    yes,
    no,
    unset,
    na,
    score,
    gaps,
    stale,
    readiness_pct,
    pid_mapped,
    overridden,
  };
}
